jQuery(document).ready(function($){

    // Move Date before title

    $('.fusion-post-grid .fusion-single-line-meta').each(function(){

        $(this).siblings('.entry-title').before(this);

    });



    $(".fusion-main-menu .menu-item.menu-item-311").click(function(){

        $(this).toggleClass("lado");

    });



    $(".fusion-main-menu .menu-item.menu-item-311 a").click(function(){

        $(".submenu__wrapper").toggleClass("submenu__active");

    });



    $(".fusion-flyout-menu-toggle, .submenu__toggle").click(function(){

        $(".submenu__wrapper").removeClass("submenu__active");

        console.log("Lado");

    })



    $(".mp__accordian .fusion-panel:first-child .panel-heading .panel-title a").addClass('active').removeClass('collapsed').attr('aria-expanded', 'false').attr('aria-selected', 'false');

    $('.mp__accordian .fusion-panel:first-child .panel-collapse').css('height', 'auto').removeClass('collapse');



    $(".mp__accordian .fusion-panel:not(:first-child) .panel-heading").click(function(){

        $(".mp__accordian .fusion-panel:first-child .panel-heading .panel-title a").removeClass('active').addClass('collapsed').attr('aria-expanded', 'true').attr('aria-selected', 'true');

        $('.mp__accordian .fusion-panel:first-child .panel-collapse').css('height', '0').addClass('collapse');

    });

});



jQuery(window).ready(function($){

    setInterval(function(){ 

      $('.inner__banner').addClass("reduce__height")

    }, 2000);

  

});



// Initialize and add the map

function initMap() {

    const gmapPin = { lat: -33.86991, lng: 151.2042267 };

    const map = new google.maps.Map(document.getElementById("map"), {

      zoom: 17,

      center: gmapPin,

      mapId: 'b36e3beb77001003'

    });    

  

    const contentString = 

        '<div class="info__window">' +

        '<h4>Insight MP</h4>' +

        '<p>Level 10, 60 York Street, <br>Sydney, NSW, Australia</p>' +

        "</div>";

    

    const infowindow = new google.maps.InfoWindow({

        content: contentString,

    });

  

    const iconBase ='https://insight.local/wp-content/themes/insight-mp/assets/images/';

    const marker = new google.maps.Marker({

      position: gmapPin,

      map: map,

      icon: iconBase + 'pin.svg'

    });

  

    marker.addListener("click", () => {

        infowindow.open({

            anchor: marker,

            map,

            shouldFocus: true,

        });

    });

}



window.initMap = initMap;



